import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { BannerComponent } from './layout/banner/banner.component';
import { FooterComponent } from './layout/footer/footer.component';
import { ConfigService } from './services/config.service';

@Component({
  selector: 'app-root',
  imports: [BannerComponent, FooterComponent, RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class App implements OnInit {
  private readonly config = inject(ConfigService);

  ngOnInit(): void {
    this.config.fetchAllowCopyPaste();
  }
}
